import React from 'react';
import { Grid } from './../../../../themes/default';
import { CardDefault } from './../../../../components/includes/card';
import { Btn } from './../../../../components/includes/ui';

class BuilderSelector extends React.Component {

  /*
  ** @Event
  ** @Description: Select option
  */

  handleSelect = (type) => {
    this.props.onSelect(type);
  }

  render() {

    return(

      <Grid container spacing={24}>

        <Grid item xs={6}>
          <CardDefault
            bordered
            title="Elección múltiple"
            subheader="Dale a tu audiencia la opción de elegir múltiples opciones."
            footer= {
              <div>
                <Btn
                  aria-label="Seleccionar"
                  color="primary"
                  onClick={ () => {
                    this.handleSelect({
                      type: "multiple",
                      title: "Elección múltiple",
                      subheader: "Dale a tu audiencia la opción de elegir múltiples opciones."
                    })
                  }}
                >
                  Seleccionar
                </Btn>
              </div>
            }
          >
          </CardDefault>
        </Grid>

        <Grid item xs={6}>
          <CardDefault
            bordered
            title="Elección única"
            subheader="Dale a tu audiencia la opción de elegir una opción entre varias."
            footer= {
              <div>
                <Btn
                  aria-label="Seleccionar"
                  color="primary"
                  onClick={ () => {
                    this.handleSelect({
                      type: "option",
                      title: "Elección única",
                      subheader: "Dale a tu audiencia la opción de elegir una opción entre varias."
                    })
                  }}
                >
                  Seleccionar
                </Btn>
              </div>
            }
          >
          </CardDefault>
        </Grid>

        <Grid item xs={6}>
          <CardDefault
            bordered
            title="Puntuación"
            subheader="Pídele a tu audiencia que califiquen algo."
            footer= {
              <div>
                <Btn
                  aria-label="Seleccionar"
                  color="primary"
                  onClick={ () => {
                    this.handleSelect({
                      type: "valuation",
                      title: "Puntuación",
                      subheader: "Pídele a tu audiencia que califiquen algo."
                    })
                  }}
                >
                  Seleccionar
                </Btn>
              </div>
            }
          >
          </CardDefault>
        </Grid>

        <Grid item xs={6}>
          <CardDefault
            bordered
            title="Texto"
            subheader="Pídele a tu audiencia una respuesta."
            footer= {
              <div>
                <Btn
                  aria-label="Seleccionar"
                  color="primary"
                  onClick={ () => {
                    this.handleSelect({
                      type: "text",
                      title: "Texto",
                      subheader: "Pídele a tu audiencia una respuesta."
                    })
                  }}
                >
                  Seleccionar
                </Btn>
              </div>
            }
          >
          </CardDefault>
        </Grid>

      </Grid>

    )
  }

}

export default BuilderSelector;
